import React from 'react'
import styled from 'styled-components'
import { Category } from './Category'
import { Carousel } from '../Common'
import { ImageField, TextField } from '@sentecacommerce-theme/base'

export type CategoriesMobileCarouselProps = {
  data: CategoryItemType[]
  defaultAlt: TextField
}

export type CategoryItemType = {
  header: TextField
  image: ImageField
  link: TextField
}

export const CategoriesMobileCarousel = ({
  data,
  defaultAlt,
}: CategoriesMobileCarouselProps) => {
  return (
    <Container>
      <Carousel
        slides={data}
        renderSlide={(item) => <Category data={item} defaultAlt={defaultAlt} />}
      />
    </Container>
  )
}

const Container = styled.div.attrs({
  className: 'container mt-5 pt-5',
})``
